// @ constants
const actionTypes = require('constants/actionTypes');
const { CARD_CHARGE_OPERATION_CHARGE } = require('constants/index');

// @ commons
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const { baseRequestData, confirmationRequest, confirmationSuccess, confirmationFailure } = require('actions/cardCharge');

const moneyRequestConfirmationRequest = () => ({
    type: actionTypes.OPENYOUNG_CARD_GET_MONEY_REQUEST_CONFIRMATION
});

const moneyRequestConfirmationSuccess = () => ({
    type: actionTypes.OPENYOUNG_CARD_GET_MONEY_REQUEST_CONFIRMATION_SUCCESS
});

const moneyRequestConfirmation = (cardId, requestStatus) => (dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId]);
    const moneyRequestDetail = getState().openYoungCardMoneyRequest.get('moneyRequestDetail');
    const panNumber = immCard.getIn(['interventionList', 0, 'pan']);
    const actualAmount = getState().cardCharge.getIn(['steps', 0, 'amount']);
    const parentComment = moneyRequestDetail.getIn(['parentComment']);
    const requestId = moneyRequestDetail.getIn(['requestId']);

    let requestData = {
        query: {
            childDetail: {
                contractNumber: immCard.getIn(['contract', 'number']),
                pan: panNumber && panNumber.substr(-4),
                productCode: immCard.getIn(['contract', 'product'])
            },
            requestMoney: {
                actualAmount,
                parentComment,
                requestId,
                requestStatus
            }
        }
    };

    dispatch(moneyRequestConfirmationRequest());
    return APIPost({
        dispatch,
        endpoint: 'openYoungMoneyRequestConfirmation',
        params: requestData
    })
        .then(responseSuccess => dispatch(moneyRequestConfirmationSuccess(responseSuccess)))
        .catch(response => {
            if (!!response.error) {
                dispatch(moneyRequestConfirmationSuccess(response));
            } else {
                throw response;
            }
        });
        /*  Pragati: SUCCESS has been called on purpose here even if the call fails because, the actual CARGA API will always be successful before this API call
            and only the notification has failed. So, we show success if only NOTIFICATION API failed. Confirmed with API team and PO */
}

const postChange = (cardId, requestStatus) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCardCharge = getState().cardCharge;
        const immCardChargeStep1 = immCardCharge.getIn(['steps', 0]);

        const accountId = immCardChargeStep1.get('accountId');
        const cardId = immCardChargeStep1.get('cardId');

        const liquidationData = immCardCharge.getIn(['extra', 'liquidationData']).toJS();

        const requestData = baseRequestData(getState, cardId, accountId);
        requestData.query.dataToken = dataToken;
        requestData.query.datosPreliq = liquidationData,
        requestData.query.importeOperacion.importe = immCardChargeStep1.get('amount'),

        dispatch(confirmationRequest());
        const confirmationEndpoint = ( immCardChargeStep1.get('operationType') === CARD_CHARGE_OPERATION_CHARGE ) ? 'eCardChargeConfirmation' : 'eCardDischargeConfirmation';
        return APIPost({
            dispatch,
            endpoint: confirmationEndpoint,
            params: requestData
        })
            .then((response) => {
                dispatch(outdateGlobalPosition());
                dispatch(confirmationSuccess(response));
                return dispatch(moneyRequestConfirmation(cardId, requestStatus));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(confirmationFailure(response.error));
                } else {
                    throw response;
                }
            });
    };
    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
}

const rejectMoneyRequest = () => {
    return {
        type: actionTypes.OPENYOUNG_CARD_REJECT_REQUEST
    }
}

const rejectMoneyRequestCall = (cardId, requestStatus) => (dispatch) => {
    dispatch(rejectMoneyRequest());
    dispatch(moneyRequestConfirmation(cardId, requestStatus));
}

const getMoneyRequestDetailsRequest = () => {
    return {
        type: actionTypes.OPENYOUNG_CARD_GET_MONEY_REQUEST_DETAIL_REQUEST
    }
}

const getMoneyRequestDetailsError = (error) => {
    return {
        type: actionTypes.OPENYOUNG_CARD_GET_MONEY_REQUEST_DETAIL_ERROR,
        payload: {
            error
        }
    }
}

const getMoneyRequestDetailsSuccess = (moneyRequestDetail) => {
    return {
        type: actionTypes.OPENYOUNG_CARD_GET_MONEY_REQUEST_DETAIL_SUCCESS,
        payload: {
            moneyRequestDetail
        }
    }
}

const getMoneyRequestDetails = (referenceId, data = {}) => (dispatch) => {
    dispatch(getMoneyRequestDetailsRequest());

    const requestData = {
        query: {
            requestId: referenceId
        }
    };

    return APIPost({
        dispatch,
        url: apiURLBuilder.getURL('openYoungMoneyRequestDetails'),
        params: requestData
    })
        .then(response => {
            dispatch(getMoneyRequestDetailsSuccess(response));
            data.successCallback && data.successCallback(data.path, response);
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getMoneyRequestDetailsError(response.error.description));
                data.errorCallback && data.errorCallback();
            } else {
                throw response;
            }
        });
}

module.exports = {
    getMoneyRequestDetails,
    moneyRequestConfirmation,
    postChange,
    rejectMoneyRequestCall
}
